import { useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthStatus } from '../../modules/enums/status';
import { useAuth, useLoading } from '../../modules/hooks';
import { routes } from '../../modules/mappers/urls';
import { AbilityContext } from '../../modules/utils/can';
import { ignoredRoutes, normalizeRoutes } from '../../modules/utils/ignoredRoutes';

export const ProtectedRouteByRoles = ({
  children,
  component,
}: {
  children: React.ReactNode;
  component: string;
}): JSX.Element | null => {
  const location = useLocation();
  const { authStatus, permissionsLoading } = useAuth() || {};
  const ability = useContext(AbilityContext);
  const { setLoading } = useLoading()!;

  useEffect(() => {
    setLoading(!ability || !!permissionsLoading);
  }, [ability, permissionsLoading, setLoading]);

  const isIgnored = ignoredRoutes.some((route) => location.pathname.startsWith(route));

  if (isIgnored) {
    return children as JSX.Element;
  }

  if (
    !ability.can('view', normalizeRoutes(component)) &&
    authStatus === AuthStatus.signedIn
  ) {
    return <Navigate to={routes.HOME} replace state={{ from: location }} />;
  }

  return children as JSX.Element;
};
